import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';

import { selectNotes } from '../../store/selectors/faqsNotesDocuments';
import Notes from '../../components/Notes';
import { fetchFaqsNotesDocuments, saveFaqsNotesDocuments,updateFaqsNotesDocuments,deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch,clearSearch } from '../../store/actions/search';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';

class ItemNotes extends Component {
  constructor(props) {
    super(props);
  }

  state = {
   loading:true
  };

  componentDidMount() {
    this.props.clearSearch()

    // Modified by: Tarkeshwar Prasad Yadav
    // Modified on: 23/08/2022
    // Jira ticket: JUN-3051
    // Comment: Added setTimeout to give enough time to filter data and to set all the relevant data to show.
    setTimeout(()=>this.setState({loading:false}),3000)
  }

  onSaveNote = note => {
    const {  onSaveFaqsNotesDocuments,onUpdateFaqsNotesDocuments  } = this.props;
    
    let utcTime = ''
    if(note.appointment){
   
    let date = new Date(note.appointment.date);
    let time = new Date(note.appointment.time)
    let hours = time.getHours();
    let minutes =time.getMinutes();
    date.setHours(hours);
    date.setMinutes(minutes)
   
    //  utcTime = date.toUTCString()
    utcTime = date
    }

 
    if(note.id){
      let data = {
        ItemId: this.props.item.id,
        "id": note.id,
        Name: 'NOTES',
        Type: 'NOTES',
        ItemType: 'Item',
        "data": JSON.stringify(note).toString(),
        "UserId": this.props.user.id,
        'visibilityType':note.visibilityType,
        noteVisibleToHomeownerOccupantRealtor:note.noteVisibleToHomeownerOccupantRealtor,
      }
   

      if(note.appointment){
        data.ReminderDate = utcTime
      }

      onUpdateFaqsNotesDocuments(data)

    }else{
      note = { ...note,'author':{
        "id": this.props.user.id,
        "firstName": this.props.user.firstname,
        "lastName": this.props.user.lastname
      },'createdAt': new Date()}
      let data = {
        ItemId: this.props.item.id,
        Name: 'NOTES',
        Type: 'NOTES',
        ItemType: 'Item',
        Data: JSON.stringify(note).toString(),
        UserId: this.props.user.id,
        'visibilityType':note.visibilityType,
        noteVisibleToHomeownerOccupantRealtor:note.noteVisibleToHomeownerOccupantRealtor,
      }

      if(note.appointment){
        data.ReminderDate = utcTime
      }
      onSaveFaqsNotesDocuments(data)
    }
  }

  render() {
    const { notes, item,onDeleteFaqsNotesDocuments,setSearch, loader } = this.props;
    return (
      this.state.loading ? <Loader /> :
      <Notes
        from={'inventoryItems'}
        breadcrumb={item.name}
        notes={notes}
        onSaveNote={this.onSaveNote}
        onDeleteNote={ notes => onDeleteFaqsNotesDocuments({...notes,Type:'NOTES'})}
        onSearch={e => setSearch({ notes: e.target.value.trim() })}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  notes: selectNotes(state),
  user: selectAuthenticatedUser(state),
  loader:selectPRLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchFaqsNotesDocumentss: fetchFaqsNotesDocuments,
  onSaveFaqsNotesDocuments: saveFaqsNotesDocuments,
  onUpdateFaqsNotesDocuments:updateFaqsNotesDocuments,
  onDeleteFaqsNotesDocuments:deleteFaqsNotesDocuments,
  setSearch,
  clearSearch
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ItemNotes);
